import React, { useState } from "react";
import styles from "./Report.module.scss";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";
import moment from "moment-timezone";
import { FileSpreadsheet, FileText, Mail, MoreHorizontal } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { Button } from "../../components/ui/button";

const ActionRender = ({ rcellItem, clientsListCSV, setDownloadCSVData, downloadPDF, downloadExcel, startDate, endDate, handleEmailIconClick, name }) => {
    const [anchorEl, setAnchorEl] = useState(null);
  
    const handlePopoverOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handlePopoverClose = () => {
      setAnchorEl(null);
    };

    const names = (name === "TimeSheetReport")
        ? `${rcellItem?.firstName ?? ""} ${rcellItem?.lastName ?? ""}`.trim()
        : (name === "ActivityReport" || name === "CheckInCheckOutReport")
            ? rcellItem?.employeeName ?? "Unknown Employee"
            : rcellItem?.clientName ?? "Unknown Client";

    const open = Boolean(anchorEl);
    return (
      <>
        <div className={`${styles.Action} d-flex flex-center`}>
          <Link rel="noopener" className={styles.Action}>
            <Mail
              className="h-5 w-5 mr-6 text-green-600"
              onClick={() => handleEmailIconClick(rcellItem)}
            />
          </Link>
          <Popover>
            <PopoverTrigger asChild>
              <button className="flex items-center justify-center h-5 w-5 text-green-600 hover:bg-transparent focus:outline-none">
                <MoreHorizontal className="h-5 w-5" />
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-40">
              <div className="space-y-2">
                <Button
                  variant="ghost"
                  className="w-full justify-start h-8"
                  onClick={() => {
                    downloadPDF(rcellItem);
                  }}
                >
                  <FileText className="mr-8 h-3 w-3" />
                  PDF
                </Button>
                <Button
                  variant="ghost"
                  className="w-full justify-start h-8"
                  onClick={() => {
                    downloadExcel(rcellItem);
                  }}
                >
                  <FileSpreadsheet className="mr-8 h-3 w-3" />
                  Excel
                </Button>
                <CSVLink
                  data={clientsListCSV}
                  filename={`${name}_${names}_${moment(startDate).format(
                    "YYYY-MM-DD"
                  )}_${moment(endDate).format("YYYY-MM-DD")}.csv`}
                  asyncOnClick={true}
                  onClick={(event, done) => {
                    setDownloadCSVData(event, done, rcellItem);
                  }}
                  className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                >
                  <FileSpreadsheet className="mr-16 h-4 w-4" />
                  <span className="font-medium">CSV</span>
                </CSVLink>
              </div>
            </PopoverContent>
          </Popover>
        </div>

        {/* <Popover
          id="popover"
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            // vertical: 'left',
            horizontal: "left",
          }}
          transformOrigin={{
            // vertical: 'left',
            horizontal: "right",
          }}
          PaperProps={{
            style: {
              boxShadow: "none",
  
              // padding: '50px', // Add some padding
            },
          }}
        >
          <div className={styles.box}>
            <div className={styles.box2}>Download</div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "left",
                left: 20,
              }}
            >
              <div>
                <CSVLink
                  data={clientsListCSV}
                  filename={`${name}_${names}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}.csv`}
                  className={styles.Link}
                  asyncOnClick={true}
                  onClick={(event, done) => {
                    setDownloadCSVData(event, done, rcellItem);
                  }}
                >
                  csv
                </CSVLink>
              </div>
              <div>
                <button
                  onClick={() => { downloadExcel(rcellItem); }}
                  className={styles.Link}
                  style={{ background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer', fontSize:'small' }}
                >
                  Excel
                </button>
              </div>
              <div>
                <button
                  onClick={() => { downloadPDF(rcellItem); }}
                  className={styles.Link}
                  style={{ background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer', fontSize:'small' }}
                >
                  Pdf
                </button>
              </div>
            </div>
          </div>
        </Popover> */}
      </>
    );
  };

export default ActionRender;